import { createContext } from 'react'

/**
 * Contexte pour partager les données entre les composants du Modal
 */
export const ModalContext = createContext({
  onClose: () => {},
  isOpen: false
})